import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="千華駐科技"
        brandName="千華駐科技"
        englishName="CHIANVA"
      />
      <Footer />
    </>
  );
}
